// src/store/transito/getters.ts
import { TransitoState } from ".";

export default {
  selectedFilters: (state: TransitoState) => state.selectedFilters,
  transitoData: (state: TransitoState) => state.transitoData,
  loading: (state: TransitoState) => state.loading,
  errorMessage: (state: TransitoState) => state.errorMessage,
};